import React from 'react';
import PropTypes from 'prop-types';
import {
  IonButton,
  IonModal,
  IonHeader,
  IonContent,
  IonTitle,
  IonIcon,
  IonToolbar,
} from '@ionic/react';
import { locationOutline } from 'ionicons/icons';

function LocationPermissionModal({ open, onClose }) {
  return (
    <IonModal isOpen={open} onDidDismiss={onClose}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Location Services</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <div className="full-height ion-padding">

          <div className="permission-location-header">
            <IonIcon
              className="permission-location-icon"
              icon={locationOutline}
              color="success"
            />

            <h1>Enable location services</h1>
          </div>

          <div className="flex-content">
            <p>Vēmos Pay uses your location for two functional reasons:</p>

            <section>
              <ol>
                <li>To allow you to view and pay your check at a nearby restaurant or bar</li>
                <li>To automatically close your open check if you forget to pay before leaving</li>
              </ol>
            </section>

            <p>We only use your location in the background when you have an open check and is only used to know if you have left the venue.</p>
          </div>

          <IonButton
            color="secondary"
            expand="block"
            fill="solid"
            type="button"
            onClick={onClose}
          >
            Continue
          </IonButton>
        </div>
      </IonContent>
    </IonModal>
  );
}

LocationPermissionModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default LocationPermissionModal;
